import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Loader from '../utils/Loader';
import RenderError from '../utils/RenderError';
import axios from 'axios';

import { isStrongPassword, PASSWORD_STRENGTH } from '../utils/utils';
import successHandle from '../utils/successHandle';
import errorHandle from '../utils/errorHandle';

document.querySelector('html body').style.background = '#f6f9fa';

const CHANGE_PASSWORD_API_END_POINT = process.env.REACT_APP_API_URL + "/api/user/change-password";

const dataState = {
  loading: false,
  password: '',
  passwordStatus: '',
}

const errorState = {
  passwordError: '',
  confirmPasswordError: '',
  resetPasswordError: ''
}

const intialState = { ...dataState, ...errorState }

const ResetPassword = () => {
  const { resetPasswordToken } = useParams();

  useEffect(() => {
    if (!resetPasswordToken) {
      navigate('/login')
    }
  }, [resetPasswordToken])

  const navigate = useNavigate();
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const onFocusPassword = () => setState({ passwordError: '', passwordStatus: '', resetPasswordError: '' });

  const validatePassword = () => {
    if (!state.password) {
      setState({ passwordError: '*Please Enter a valid password!' })
    }
  }

  const checkStrength = (pass) => {
    if (pass.length > 15) {
      setState({ passwordError: "*Password is too lengthy" })
      return
    }
    else if (pass.length < 8) {
      setState({ passwordError: "*Password is too short" })
      return;
    }

    if (isStrongPassword(pass)) {
      setState({ passwordStatus: 'Password is strong' });
    }

    let count = 0;
    let regex1 = /[a-z]/;
    if (regex1.test(pass)) count++;
    let regex2 = /[A-Z]/;
    if (regex2.test(pass)) count++;
    let regex3 = /[\d]/;
    if (regex3.test(pass)) count++;
    let regex4 = /[!@#$%^&*.?]/;
    if (regex4.test(pass)) count++;
    setState({ passwordError: '', passwordStatus: PASSWORD_STRENGTH[count] })
  }

  useEffect(() => {
    if (!state.password) {
      return;
    }

    checkStrength(state.password)
  }, [state.password]);

  const changePassword = async (e) => {
    e.preventDefault();
    setState({ loading: true })
    const isValid = state.password && !state.passwordError;
    if (!isValid) {
      setState({ answerError: 'Please enter a valid details!', loading: false })
      return;
    }

    const data = { password: state?.password, resetPasswordToken }
    await axios.post(CHANGE_PASSWORD_API_END_POINT, data)
      .then((res) => {
        const { message } = res.data;
        setState({ loading: false });
        successHandle(message);
        navigate('/login');
      })
      .catch((error) => {
        errorHandle(error);
        setState({ loading: false });
      })
  }

  return (
    <div className='mt-4 gleamDesk-auth'>
      <div class="container d-flex justify-content-center align-items-center">
        <div class="page-login">
          <div class="text-center">
            <Link class="navbar-brand mb-4 h1" to="/login">
              <img src="/assets/img/gleamDesk.png" style={{ height: '8.5rem' }} class="navbar-brand-image d-inline-block align-top mr-2" alt="" />
            </Link>
          </div>

          <div class="card mb-0">
            <div class="card-body">
              <form id="validate-password-form" onSubmit={changePassword}>
                <div class="form-group mb-2">
                  <label for="exampleDropdownFormEmail1" class="form-label">Enter new password?</label>
                  <input
                    type="password"
                    class="form-control"
                    id="exampleDropdownFormtext1"
                    placeholder="Password"
                    value={state.password}
                    onChange={(e) => setState({ password: e.target.value })}
                    onFocus={onFocusPassword}
                    onBlur={validatePassword}
                    disabled={state.loading}
                  />
                  <div><RenderError error={state.passwordError} /></div>
                  <div><RenderError error={state.passwordStatus} /></div>
                </div>

                <div className='pb-3 text-center'>
                  <Loader isLoading={state.loading} />
                </div>

                <button
                  type="submit"
                  class="btn btn-sm btn-block btn-primary w-100 fw-600"
                  disabled={state.loading}
                  onClick={changePassword}
                >
                  Change password
                </button>
                <div className='text-center fw-500 mt-2'>
                  <RenderError error={state.resetPasswordError} />
                </div>

              </form>
            </div>
            <div class="card-footer text-center fw-600">
              <Link to="/login"><small>Login</small></Link>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default ResetPassword
